import $ from "jquery";
import swiperSlider from "../swiperSlider/swiperSlider";

const riderSlider = {
  variable: {
    url: window.location.href,
  },
  methods: {
    addSwiper: (element) => {
      let config = {
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3.2,
            spaceBetween: 20,
          },
        },

        navigation: {
          nextEl: ".custom-navigation-next",  
          prevEl: ".custom-navigation-prev", 
        },
      };

      const swiperElement = $(element).find(".rider-slider__swiper-box--swiper").get(0);
      if (swiperElement) {
        swiperSlider.methods.initializerSwiper(swiperElement, config);
      }
    },
    init: () => {
      $(".rider-slider").each((idx, ele) => {
        riderSlider.methods.addSwiper(ele);
      });

      $(window).on("resize", () => {
        $(".rider-slider").each((idx, ele) => {
          riderSlider.methods.addSwiper(ele);
        });
      });
    },
    riderButtonClickHandler: function (e) {
      $(document).on('click', '.ridersComponent .chli_btn--primary', function(e) {
        if ($(this).closest('.ridersComponent').length) {
          var title = $(this).closest('.ridersComponent').prev().find('.chli_title').text();
          var buttonText = e.currentTarget.innerText.replace(/\n/g, '').trim();
          var planOption=$(this).closest('.rider-slider__swiper-wrapper--slide').find('.rider-slider__title')
          .text().replace(/\s+/g, ' ').trim();
          var obj = riderSlider.methods.dataLayerObj(buttonText, title,planOption);
          createDataLayer('buttonClick', obj);
        }
      });
    },
    riderListScrollClickHandler: function() {
      $('.riders-component__prev-button').on('click', function() {
        let buttonName="previous";
        let container=$(this).closest('.genericContainer');
        let pageSection;
        let prevContainer;
        if(container!=null){
          pageSection=container.find('.chli_title').find('h2').text().replace(/\s+/g, ' ').trim();
        }
        if(container.length==0)
        {
           let parent = $(this).closest('.ridersComponent');
           prevContainer=parent.prev('.genericContainer');
           pageSection=prevContainer.find('.chli_title').find('h2').text().replace(/\s+/g, ' ').trim();
        }
        if(pageSection==''){
          prevContainer=container.prev('.genericContainer');
          pageSection=prevContainer.find('.chli_title').find('h2').text().replace(/\s+/g, ' ').trim();
        }
        var obj = riderSlider.methods.dataLayerObj(buttonName,pageSection);
        createDataLayer('List_Scroll_Previous', obj);
      });
      $('.riders-component__next-button').on('click', function() {
        let buttonName="next";
        let container=$(this).closest('.genericContainer');
        let pageSection;
        let prevContainer;
        if(container!=null){
          pageSection=container.find('.chli_title').find('h2').text().replace(/\s+/g, ' ').trim();
        }
        if(container.length==0)
        {
           let parent = $(this).closest('.ridersComponent');
           prevContainer=parent.prev('.genericContainer');
           pageSection=prevContainer.find('.chli_title').find('h2').text().replace(/\s+/g, ' ').trim();
        }
        if(pageSection==''){
          prevContainer=container.prev('.genericContainer');
          pageSection=prevContainer.find('.chli_title').find('h2').text().replace(/\s+/g, ' ').trim();
        }
        var obj = riderSlider.methods.dataLayerObj(buttonName,pageSection);
        createDataLayer('List_Scroll_Next', obj);
      });

    },
    dataLayerObj: function (e, el,planOption) {
      var obj = {
        'articleName': "",
        'blogCategory': "",
        'blogPageCategory': "",
        'buttonText': e ? e : "",
        'pageSection': el ? el.replace(/\n/g, '').trim() : "",
        'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? riderSlider.variable.url.includes("blog") ? "Blogs" : riderSlider.variable.url.substring(riderSlider.variable.url.indexOf(".com/"), riderSlider.variable.url.lastIndexOf('/') === ".com") && !riderSlider.variable.url.substring(riderSlider.variable.url.indexOf(".com/"), riderSlider.variable.url.length - 1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
        'planOption': planOption ? planOption : "",
        'productCategory': "",
        'productName': "",
        'question': "",
        'source': "",
        'searchTerm': "",
        'videoTitle': "",
        'bannerName': "",
      };
      return obj;
    },
  }
};

$(() => {
  riderSlider.methods.init();
});

$(document).ready(function () {
  riderSlider.methods.riderButtonClickHandler();
  riderSlider.methods.riderListScrollClickHandler();
});
